define('NVT.anuualupdateform.anuualupdateformUpdateContact.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_update_contact.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_myorganisation_update_contact_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_myorganisation_update_contact_tpl

        , title: Utils.translate('Update Contact')

        ,initialize: function(options)
            {
                this.options = options;
                this.getjsonrequest = options.getjsonrequest;
                this.application = options.application;
                this.page_header = "Update Contact";	
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }

        ,    events: 
            {
                'change [data-action="indstatusregined"]': 'IndstStusRegined',
                'submit form': 'saveTheForm',
                'click [data-dismiss="modal"]': 'onDismissModal',
                'click [data-action="whateachrolemeans"]': 'openWhateachrolemeansModel',
                'input [name="nus_ems_name"]': 'forceUppercase',
                'input [name="nus_ems_name_last"]': 'forceUppercase',
                'input [name="nus_job_title"]': 'forceUppercase'
            }   
            
        ,   forceUppercase: function (e)
            {
                var el = e.target;
                var pos = el.selectionStart;
                el.value = el.value.toUpperCase();
                el.setSelectionRange(pos, pos);
            }
            
        ,	openWhateachrolemeansModel: function (e){

                e.preventDefault();
                var self = this;
                var application = this.application;

                jQuery('.nvt-what-each-role-overlay').remove();

                var roles = [
                    { icon: '&#128119;', name: 'C-Suite', desc: 'Chief Executive Officer / Managing Director / Executive Director / General Manager / Key organisational decision contact.' },
                    { icon: '&#129534;', name: 'Finance', desc: 'Receives electronic invoice / SOA on membership from SBF and makes payment.' },
                    { icon: '&#128101;', name: 'HR', desc: 'Main contact point for Membership Update Exercises and eDMs, and disseminates them to company staff.' },
                    { icon: '&#128227;', name: 'Liaison Officer', desc: 'Receives latest information / eDMs on SBF activities and disseminates them to company staff.' },
                    { icon: '&#128231;', name: 'Participants and eDM Recipients', desc: 'Receives SBF event invitations, updates, and general email communications, and may be invited to participate in events.' },
                    { icon: '&#128221;', name: 'Exemption Application Contact', desc: 'Contact point regarding exemption applications (e.g. submission, clarifications, or status updates).' }
                ];

                var $content = jQuery(
                    '<div style="font-size:0.92rem; line-height:1.6; color:#0e2147;">' +
                        // '<p style="margin:0 0 1.1rem; color:#334155;">' + Utils.translate('Each Contact Category reflects the role a contact plays for your organisation with SBF. A contact may be tagged with more than one category.') + '</p>' +
                        '<div style="display:flex; flex-direction:column; gap:0.75rem;">' +
                            _.map(roles, function(role)
                            {
                                return '<div style="display:flex; align-items:flex-start; gap:0.7rem; background:#f8fafc; border:1px solid #e2e8f0; border-radius:10px; padding:0.8rem 1rem;">' +
                                    '<span style="flex-shrink:0; width:1.8rem; height:1.8rem; border-radius:50%; background:#eef6fb; color:#0e6ba8; display:flex; align-items:center; justify-content:center; font-size:0.95rem;">' + role.icon + '</span>' +
                                    '<div>' +
                                        '<strong style="display:block; color:#0e2147; font-size:0.9rem; margin-bottom:0.15rem;">' + Utils.translate(role.name) + '</strong>' +
                                        '<span style="color:#334155;">' + Utils.translate(role.desc) + '</span>' +
                                    '</div>' +
                                '</div>';
                            }).join('') +
                        '</div>' +
                    '</div>'
                );

                var $overlay = jQuery(
                    '<div class="nvt-what-each-role-overlay" style="position:fixed; inset:0; background:rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:999999999; padding:1.5rem;">' +
                        '<div class="nvt-what-each-role-dialog" style="max-width:560px; width:100%; max-height:85vh; overflow-y:auto; background:#ffffff; border-radius:12px; box-shadow:0 20px 60px rgba(0,0,0,0.25); padding:1.75rem 2rem; position:relative;">' +
                            '<button type="button" data-action="what-each-role-close" style="position:absolute; top:1rem; right:1.25rem; background:none; border:none; font-size:1.4rem; line-height:1; color:#9ca3af; cursor:pointer;" aria-label="Close">&#10005;</button>' +
                            '<h2 style="margin:0 0 1rem 0; font-size:1.15rem; font-weight:700; color:#0e2147;">' + Utils.translate('What Each Role Means?') + '</h2>' +
                        '</div>' +
                    '</div>'
                );

                $overlay.find('.nvt-what-each-role-dialog').append($content);

                $overlay.on('click', '[data-action="what-each-role-close"]', function (e)
                {
                    e.preventDefault();
                    $overlay.remove();
                });

                jQuery('body').append($overlay);
            }

        ,   IndstStusRegined: function (e)
            {
                e.preventDefault();
                var self=this;
                var id= jQuery(e.target).val();
                //jQuery(".classresigned").text('');
                jQuery(".classresigned").hide();
                if( id == '3')
                {
                    jQuery(".classresigned").show();
                    //var getreginedtext = SC.CONFIGURATION.MyCoolModule.resigned || '';
                    //jQuery(".classresigned").text(getreginedtext)
                }             
            }

        ,   validatePhoneNumber : function(phone) {
            var self = this;
            var cleaned = phone.replace(/[\s()-]/g, '');
            var regex = /^\+?[1-9]\d{6,14}$/;
            return regex.test(cleaned);
        }

        ,   saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	getfielddata = $target.serializeObject();
                    
                if(!getfielddata.nus_ems_name.trim() && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Given name is required', 'error','nus_ems_name');
                }
                else if(!getfielddata.nus_ems_name_last.trim() &&getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Surname is required', 'error','nus_ems_name_last');
                }
                else if(!getfielddata.nus_job_title.trim() && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Job title is required', 'error','nus_job_title');
                }
                else if((getfielddata.nus_phone_no =='' || getfielddata.nus_phone_no.length < 8) && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Business Contact number is required', 'error','nus_phone_no');
                }
                else if((getfielddata.nus_phone_no !='' || getfielddata.nus_phone_no.length > 8) && !self.validatePhoneNumber(getfielddata.nus_phone_no) && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Business Contact number is Invalid', 'error','nus_phone_no');
                }
                else if(!getfielddata.formtypes || !getfielddata.nus_email_address.trim() || !getfielddata.internalid)
                {
                    self.showMessage('The email address used for login is required.', 'error','nus_email_address');  
                }
                   else if(!getfielddata.nus_contactdesignation)
                {
                    self.showMessage('Please select at least one Contact Category.', 'error','nus_contactdesignation');
                }
                else if(self.hasContactIdentityChanged(getfielddata) && !getfielddata.email_confirma_know)
                {
                    self.showMessage('Please verify this information is valid or not.', 'error','email_confirma_know');
                }
                else if(getfielddata.custentity_contact_status !="3" && self.hasContactIdentityChanged(getfielddata) && !self._contactChangeConfirmed)
                    {
                        self.showContactChangeConfirmation(getfielddata);
                    }
                else
                    {
                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                        return promise && promise.then
                        (
                            function(responce)
                            {
                                if (responce.successMessage)
                                {
                                    self.showMessage(responce.successMessage, 'success');
                                }
                                else {
                                    self.showMessage(responce.errorMessage, 'error')
                                }

                                return false;   
                            }
                        );
                    }              
               
            }

        , showMessage: function(message, type, field)
            {
                jQuery('.global-views-message-error').remove(); 
                jQuery('.global-views-message-success').remove(); 

                var messageView = new MessageView
                ({
                        message: message
                    ,   type: type
                    ,   closable: type =='error' ? true : false
                });
                if (typeof field !== 'undefined')
                {
                    this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else if (type =='error'){
                    this.application.getLayout().$('form').append(messageView.render().$el);
                }
                else
                {
                    this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                    setTimeout(function() {
                        jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                    }, 1000);
                }
            }    

      ,   onDismissModal: function ()
            {
                jQuery('.nvt-contact-change-overlay').remove();
            }

        ,   escapeHtml: function (value)
            {
                return jQuery('<div>').text(value == null ? '' : value).html();
            }

        ,   hasContactIdentityChanged: function (getfielddata)
            {
                var self = this;
                var origName  = (self.options.profile.getfirstname    || '').trim();
                var origLast  = (self.options.profile.getlastname     || '').trim();
                var origEmail = (self.options.profile.getEmailAddress || '').trim();

                return getfielddata.nus_ems_name.trim()     !== origName
                    || getfielddata.nus_ems_name_last.trim() !== origLast
                    || getfielddata.nus_email_address.trim() !== origEmail;
            }

            // Custom overlay appended to <body>, outside the modal's own DOM,
            // so re-opening this form as a child popup (via Layout.showInModal,
            // which swaps the single $containerModal's content) never touches it.
        ,   showContactChangeConfirmation: function (getfielddata)
            {
                var self = this;

                jQuery('.nvt-contact-change-overlay').remove();

                var origFullName = ((self.options.profile.getfirstname || '') + ' ' + (self.options.profile.getlastname || '')).trim();
                var newFullName  = (getfielddata.nus_ems_name + ' ' + getfielddata.nus_ems_name_last).trim();

                var $overlay = jQuery(
                    '<div class="nvt-contact-change-overlay" style="position:fixed; inset:0; background:rgba(0,0,0,0.45); backdrop-filter:blur(4px); display:flex; align-items:center; justify-content:center; z-index:999999999; padding:1.5rem;">' +
                        '<div style="max-width:560px; width:100%; background:#ffffff; border-radius:12px; box-shadow:0 20px 60px rgba(0,0,0,0.25); padding:2rem 2rem 1.75rem; position:relative;">' +
                            '<button type="button" data-action="contact-change-cancel" style="position:absolute; top:1rem; right:1.25rem; background:none; border:none; font-size:1.5rem; line-height:1; color:#9ca3af; cursor:pointer; padding:0.25rem 0.5rem; border-radius:6px;" aria-label="Close dialog">&#10005;</button>' +
                            '<div style="display:flex; align-items:center; gap:0.75rem; margin-bottom:1.25rem;">' +
                                '<span style="font-size:1.5rem; line-height:1;">&#9888;&#65039;</span>' +
                                '<h2 style="margin:0; font-size:1.25rem; font-weight:600; color:#111827; letter-spacing:-0.01em;">' + Utils.translate('Contact name or email has changed') + '</h2>' +
                            '</div>' +
                            '<p style="margin:0 0 1.25rem 0; font-size:0.95rem; color:#374151; line-height:1.5;">' +
                                Utils.translate('You are editing the name or email of this contact. This may indicate the contact has left the organisation and is being replaced by someone new.') +
                            '</p>' +
                            '<div style="background:#f8fafc; border-radius:8px; padding:1rem 1.25rem; margin-bottom:1.25rem; border:1px solid #e9edf2;">' +
                                '<div style="display:flex; flex-wrap:wrap; align-items:baseline; gap:0.4rem 0.75rem; padding-bottom:0.7rem; margin-bottom:0.7rem; border-bottom:1px solid #e9edf2;">' +
                                    '<span style="font-weight:600; color:#1f2937; min-width:100px; font-size:0.9rem;">' + Utils.translate('Given Name') + '</span>' +
                                    '<span style="color:#6b7280; text-decoration:line-through; font-size:0.9rem;">' + self.escapeHtml(origFullName) + '</span>' +
                                    '<span style="color:#9ca3af; font-weight:300; margin:0 0.1rem;">&rarr;</span>' +
                                    '<span style="color:#1f2937; font-weight:500; font-size:0.9rem;">' + self.escapeHtml(newFullName) + '</span>' +
                                '</div>' +
                                '<div style="display:flex; flex-wrap:wrap; align-items:baseline; gap:0.4rem 0.75rem;">' +
                                    '<span style="font-weight:600; color:#1f2937; min-width:100px; font-size:0.9rem;">' + Utils.translate('Email') + '</span>' +
                                    '<span style="color:#6b7280; text-decoration:line-through; font-size:0.9rem;">' + self.escapeHtml(self.options.profile.getEmailAddress || '') + '</span>' +
                                    '<span style="color:#9ca3af; font-weight:300; margin:0 0.1rem;">&rarr;</span>' +
                                    '<span style="color:#1f2937; font-weight:500; font-size:0.9rem;">' + self.escapeHtml(getfielddata.nus_email_address) + '</span>' +
                                '</div>' +
                            '</div>' +
                            '<div style="background:#fefce8; border-left:4px solid #eab308; padding:0.9rem 1.1rem; border-radius:6px; margin-bottom:1.5rem; font-size:0.92rem; color:#78350f; line-height:1.5;">' +
                                '<strong style="color:#92400e;">' + Utils.translate('Important:') + '</strong> ' +
                                Utils.translate('Do not overwrite this contact. Instead, change the existing contact’s status to') +
                                ' <span style="background:#fde68a; padding:0.1rem 0.3rem; border-radius:4px; font-weight:500;">' + Utils.translate('No longer with organisation') + '</span> ' +
                                Utils.translate('and add the new person as a new contact.') +
                            '</div>' +
                            '<div style="display:grid; flex-wrap:wrap; gap:0.75rem;">' +
                                '<button type="button" data-action="contact-change-cancel" style="flex:1 1 auto; padding:0.7rem 1rem; border-radius:8px; font-size:0.85rem; font-weight:500; border:1px solid #d1d5db; background:#808080; color:#ffffff; cursor:pointer; min-width:120px;">' +
                                    Utils.translate('Cancel - I will create a new contact') + '<br> <span style="font-weight:400;font-size:0.8rem;opacity:0.9;color: #f8fafc;">' + Utils.translate("and update the existing contact's status accordingly") + '</span>' +
                                '</button>' +
                                '<button type="button" data-action="contact-change-open-child" style="display:none; flex:1 1 auto; padding:0.7rem 1rem; border-radius:8px; font-size:0.85rem; font-weight:500; border:1px solid #3b6eff; background:#eef4ff; color:#1d4ed8; cursor:pointer; min-width:120px; line-height:1.35;">' +
                                    Utils.translate('Edit in Popup') + '<br><span style="font-weight:400; font-size:0.72rem; color:#3b6eff;">' + Utils.translate('reopens this form, keeps this warning open') + '</span>' +
                                '</button>' +
                                '<button type="button" data-action="contact-change-proceed" style="flex:1 1 auto; padding:0.7rem 1rem; border-radius:8px; font-size:0.85rem; font-weight:500; border:1px solid #0E2147; background:#0E2147; color:#ffffff; cursor:pointer; min-width:120px;">' +
                                    Utils.translate('Proceed with changes') + '<br> <span style="font-weight:400;font-size:0.8rem;opacity:0.9;color: #ffffff;">' + Utils.translate('I understand I am overwriting the existing contact') + '</span>' +
                                '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
                );

                $overlay.on('click', '[data-action="contact-change-cancel"]', function (e)
                {
                    e.preventDefault();
                    $overlay.remove();
                });

                $overlay.on('click', '[data-action="contact-change-proceed"]', function (e)
                {
                    e.preventDefault();
                    self._contactChangeConfirmed = true;
                    $overlay.remove();
                    self.$('#in-modal-btnsave').closest('form').trigger('submit');
                });

                $overlay.on('click', '[data-action="contact-change-open-child"]', function (e)
                {
                    e.preventDefault();
                    self.onContactChangeOpenChild();
                     $overlay.remove();
                });

                jQuery('body').append($overlay);
            }

            // Opens a fresh copy of this same form via the app's normal modal
            // mechanism. This warning overlay lives outside $containerModal,
            // so it stays open underneath the newly opened child popup.
        ,   onContactChangeOpenChild: function ()
            {
                var self = this;
                var Layout = self.application.getLayout();

                var childView = new self.constructor
                ({
                    application:    self.application,
                    getjsonrequest: self.getjsonrequest,
                    profile:        self.options.profile,
                    model:          new self.model.constructor()
                });

                Layout.showInModal(childView);
            }

        ,getContext: function() {
            
            var self = this;
            var getdesgRemovelist = SC.CONFIGURATION.MyOrganisation.getDesignation || '';
                getdesgRemovelist= getdesgRemovelist.split(",") || [];
            var newgetdesglist = this.options.profile.getdesglist;
                if(newgetdesglist){
                    newgetdesglist = newgetdesglist.filter(item => !getdesgRemovelist.includes(item.desgid));
                }

            return {
        
               title : this.title,

               getinternalid : this.options.profile.internalid || '',

               getfirstname : this.options.profile.getfirstname || '',

               getlastname : this.options.profile.getlastname || '',

               getJobTitle: this.options.profile.getJobTitle || '',

               getPhoneNo :  this.options.profile.getPhoneNo || '',

               getEmailAddress :  this.options.profile.getEmailAddress || '',

               getdesglist : newgetdesglist || '', //this.options.profile.getdesglist || '',

               getdesignation :  this.options.profile.getdesignation || '',

               isindividualstatusActive :  this.options.profile.individualstatus === 'Active',

               isindividualstatusResigned :  this.options.profile.individualstatus === 'No longer with Organisation',

               isresignedCaption : SC.CONFIGURATION.MyCoolModule.resigned || '',

               subrole1 :  this.options.profile.getcsuite || false, // C-Suite

               subrole2 :  this.options.profile.gethr_decision_maker || false, // HR

               subrole3 :  this.options.profile.getfinance_decision_maker || false, // Finance
               
           }
         }        

    });
});
